// frontend/src/farm/fuelGifts.mjs
// What the fuel-gift UI says (spec 2026-09-29-farm-fuel-gifts-design.md): the friend row button,
// the 👫 dot, and the gifts pop-up's rows and total. Pure (node --test).
import { plural } from './vehicles.mjs';

export function giftButton(friend) {
  return friend?.gift_sent_today ? { label: '{check} Wysłano dziś', enabled: false } : { label: '{fuel} Wyślij paliwo', enabled: true };
}

export function hasNewGifts(raw) { return (raw?.farm?.new_gifts?.length ?? 0) > 0; }

// One row per friend however many canisters they sent (owner 2026-10-27: Zosia three times was three rows), in the
// order they first arrived; `count` is how many. The total still counts every canister.
export function giftsView(newGifts = [], sentTodayIds = new Set()) {
  const byId = new Map();
  for (const g of newGifts) {
    const row = byId.get(g.id);
    if (row) row.count += 1;
    else byId.set(g.id, { id: g.id, name: g.name, count: 1 });
  }
  const rows = [...byId.values()].map((r) => ({
    ...r,
    thank: sentTodayIds.has(r.id) ? { label: '{check} Wysłano', enabled: false } : { label: 'Podziękuj {fuel}', enabled: true },
  }));
  const n = newGifts.length;
  return { rows, total: `+${n} ${plural(n, 'kanister', 'kanistry', 'kanistrów')}` };
}

// The farm pop-up's line for one row (a canister holds 50 fuel).
export function giftLine({ name, count = 1 }) {
  if (count <= 1) return `${name} — kanister {fuel} 50`;
  return `${name} ×${count} — ${plural(count, 'kanister', 'kanistry', 'kanistrów')} {fuel} ${50 * count}`;
}

// The friends panel's "×3" beside a gift row; nothing for one.
export const countBadge = (count) => (count > 1 ? `×${count}` : '');
